'use strict'
import baseConfig from './axios.base.config'

const devConfig = Object.assign(baseConfig, {
})

export default devConfig
